import { Component, input } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MtrCheckboxModule } from '@mortar/angular/components/atomic/checkbox';
import { DisplayComponent } from 'app/driver-pay/persistence/core/components/displays/DisplayComponent';

@Component({
  selector: 'boolean-display',
  template: `
    @if (value() !== undefined) {
      <mtr-checkbox id="{{ this.id() ?? value() }}" disabled [checked]="!!value()" />
    }
  `,
  standalone: true,
  imports: [MtrFormFieldModule, MtrCheckboxModule],
})
export class BooleanDisplayComponent implements DisplayComponent {
  id = input<string>();
  value = input.required<object | undefined>();
}
